import { useState } from 'react'
import { Button } from '@/components/ui/button'

interface ExpandableDescriptionProps {
  description: string
  maxLength?: number
  className?: string
  defaultOpen?: boolean
}

export default function ExpandableDescription({
  description,
  maxLength = 100,
  className = '',
  defaultOpen = false,
}: ExpandableDescriptionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultOpen)

  // ถ้าความยาวของ description น้อยกว่า maxLength ให้แสดงทั้งหมดเลย
  if (description.length <= maxLength) {
    return (
      <div
        className={`text-sm ${className}`}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    )
  }

  // ตัดข้อความให้เหลือ maxLength ตัวอักษร
  const truncatedDescription = description.slice(0, maxLength) + '...'

  return (
    <div className={`text-sm space-y-2 ${className}`}>
      <div
        dangerouslySetInnerHTML={{
          __html: isExpanded ? description : truncatedDescription,
        }}
      />
      <Button
        variant="ghost"
        size="sm"
        className="text-xs text-muted-foreground hover:text-foreground p-0 h-auto font-normal"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? 'ดูน้อยลง' : 'ดูเพิ่มเติม'}
      </Button>
    </div>
  )
}
